/* eslint-disable react-hooks/exhaustive-deps */
import React, { useRef, useContext } from 'react';
import { Button, Modal } from 'antd';
import StoreNewProductModalContext from '../../../contexts/store-new-product-context/StoreNewProductProvider';
import Barcode from 'react-barcode';
import { useReactToPrint } from 'react-to-print';
import './ProductBarCodeModal.scss';
import { useTranslation } from 'react-i18next';
const ProductBarCodeModal = () => {
  const {
    selectedProduct,
    setSelectedProduct,
    barCodeModalOpened,
    setBarCodeModalOpned
  } = useContext(StoreNewProductModalContext);
  const { t } = useTranslation();
  const renderBarCodes = (num) => {
    const arr = Array.from(Array(num).keys());

    return arr.map((item, index) => (
      <div key={index} className="wrapper-ref" ref={componentRef}>
        <Barcode
          // width="4mm"
          // height="60mm"
          // ref={componentRef}
          value={
            selectedProduct?.defaultParCode
              ? selectedProduct.defaultParCode
              : selectedProduct.parCode
          }
        />
        <div
          className="p-name-price"
          style={{
            marginTop: '-17px',
            paddingLeft: '10px',
            marginRight: '10px'
          }}
        >
          <p
            style={{
              borderBottomColor: '#000',
              borderBottomStyle: 'solid',
              borderBottomWidth: '1px',
              paddingBottom: '7px'
            }}
          >
            {selectedProduct?.name}
          </p>
          <p
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              paddingLeft: '17px',
              paddingRight: '17px'
            }}
          >
            <span>SR</span>
            <span>{Number(selectedProduct?.salePrice).toFixed(2)}</span>
          </p>
        </div>
      </div>
    ));
  };

  // .wrapper-ref svg {
  //   // width: 37mm;
  //   // height: 25mm;
  // }
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    pageStyle: `
      @media print {
      @page {
        size: 50mm 25mm;
        margin: none;
      }
      .wrapper-ref {
        size: 50mm 25mm;
      }
      .p-name-price {
        width: 36mm;
      }
      .p-name-price p {
        line-height: 14px;
        font-size: 11px;
        text-align: center;
        width: 36mm;
        white-space: noWrap;
        overflow: hidden;
        text-overflow: ellipsis;
        width: 36mm;
        direction: rtl;
      }
      .wrapper-ref svg {
        margin: 0 auto;
        width: 36mm;
        height: 17mm;
      }
    `
  });

  // const handlePrint = (e) => {
  //   const opt = {
  //     scale: 4
  //   };
  //   const elem = wrapper_ref.current;
  //   html2canvas(elem, opt).then((canvas) => {
  //     const iframe = document.createElement('iframe');
  //     iframe.name = 'printf';
  //     iframe.id = 'printf';
  //     iframe.height = 0;
  //     iframe.width = 0;
  //     document.body.appendChild(iframe);

  //     const imgUrl = canvas.toDataURL({
  //       format: 'jpeg',
  //       quality: '1.0'
  //     });

  //     const style = `
  //           height:100vh;
  //           width:100vw;
  //           position:absolute;
  //           left:0:
  //           top:0;
  //       `;

  //     const url = `<img style="${style}" src="${imgUrl}"/>`;
  //     var newWin = window.frames['printf'];
  //     newWin.document.write(`<body onload="window.print()">${url}</body>`);
  //     newWin.document.close();
  //   });
  // };

  return (
    <Modal
      className="shared-custom-modal product-barcodes-modal"
      width="94%"
      style={{ maxWidth: '842px' }}
      title={` ${t('services.BarcodePrinting')}  ${
        selectedProduct?.name ? selectedProduct.name : ''
      }`}
      visible={barCodeModalOpened}
      onOk={() => {
        setBarCodeModalOpned(false);
        setSelectedProduct(null);
      }}
      onCancel={() => {
        setBarCodeModalOpned(false);
        setSelectedProduct(null);
      }}
      footer={false}
    >
      <div className="barcoes-btn">
        <div className="barcodes-wrap">{renderBarCodes(1)}</div>

        <Button
          className="print-btn"
          type="primary"
          // icon={<LoginOutlined />}
          onClick={handlePrint}
        >
          {t('services.print')}
        </Button>
      </div>
    </Modal>
  );
};

export default ProductBarCodeModal;
